const COUNT = 14;

// Deterministic spread across the width/timing instead of Math.random() -- see
// the `.petal` CSS in App.css. Purely decorative, so it's `aria-hidden` and
// ignores pointer events entirely.
//
// Each petal gets an even "slot" across the width (i / COUNT) plus a small
// jitter, rather than a single multiply-and-modulo step -- with only ~14
// samples, a plain `(i * 97) % 100` walk lands almost all of them bunched in
// one third of the width instead of spread edge to edge.
const PETALS = Array.from({ length: COUNT }, (_, i) => {
  const slot = (i / COUNT) * 100;
  const jitter = ((i * 29) % 13) - 6;
  return {
    left: `${Math.min(97, Math.max(0, slot + jitter)).toFixed(1)}%`,
    size: 8 + ((i * 37) % 10),
    duration: 9 + ((i * 53) % 8),
    delay: -((i * 31) % 20),
    drift: `${(i % 2 === 0 ? 1 : -1) * (20 + ((i * 17) % 40))}px`,
  };
});

export default function Petals() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {PETALS.map((p, i) => (
        <span
          key={i}
          className="petal"
          style={{
            left: p.left,
            width: p.size,
            height: p.size * 0.8,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            "--petal-drift": p.drift,
          }}
        />
      ))}
    </div>
  );
}
